import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
 
const Footer = () => {
  return (
    <div className="section is--footer">
      <div className="container-2"> 
        <div className="footer-2">
          <div className="footer-item is--cta">
            <div className="hero__cta">
              <a href={process.env.REACT_APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="download-button is--footer w-inline-block">
                <img src="img/app-store.svg" loading="lazy" alt="Click to download for iPhone" className="app-store-img" />
              </a>
              <a href={process.env.REACT_APP_ANDROID_URL} target="_blank" rel="noopener noreferrer" className="download-button is--footer w-inline-block">
                <img src="img/google-play.svg" loading="lazy" alt="" className="app-store-img" />
              </a>
            </div>
          </div>  
          
          <div className="footer-item is--links"> 
            <div className="footer__title">Get Started</div>
            <Link to="/pricing" className="footer__link">Pricing</Link>
            <a href={`${process.env.REACT_APP_ADMIN_URL}/login`} className="footer__link">Log In</a>
            <a href="#pricing" className="footer__link">Sign Up</a>
          </div>
          
          <div className="footer-item is--links">
            <div className="footer__title">Solutions</div>
            {/* <Link to="/selfemployed" className="footer__link" style={{ display: 'none' }}>Self Employed</Link> */}
            <Link to="/teams" className="footer__link">Teams</Link>
            <Link to="/about" className="footer__link">About Us</Link>
            <Link to="/faq" className="footer__link">FAQ</Link>
            <Link to="/terms"  className="footer__link">Terms of Service</Link>
            <Link to="/privacy"  className="footer__link">Privacy</Link>
          </div>
          
          <div className="footer-item is--links">
            <div className="footer__title">Contact Us</div>
            <div className="footer-email-container">
              <span className="footer-email-label">Email: </span>
              <a href="mailto:support@eworxs.app?subject=Hello%20Subject&body=Hello%20Body" className="footer__link footer-email-link">support@eworxs.app</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div id="copyright" className="text-s is--dimmed">© {new Date().getFullYear()} EWORXS</div>
        </div>
      </div>
    </div>
  );
};

export default Footer; 